import React, { useState } from "react";
import { Controller, useForm } from "react-hook-form";
import Button from "../../components/button";
import api from "../../api";
import { RouteKeys } from "../routes/route-keys";
import AuthCanvas from "./AuthCanvas";
import TextInput from "../../components/form-group/text-input/TextInput";
import { useHistory } from "react-router-dom";

interface ForgotPasswordFormProps {
  email: string;
}

const ForgotPassword: React.FC = () => {
  const { handleSubmit, errors, control } = useForm<ForgotPasswordFormProps>({
    shouldFocusError: true,
  });

  const history = useHistory();
  const [errorMessage, setErrorMessage] = useState<string | undefined>(
    undefined
  );

  const resetPassword = async (body: { email: string }) => {
    try {
      const response = await api.auth.forgotPassword({
        email: body.email,
        requestType: "resetPassword",
      });

      history.push({
        pathname: "/auth/reset-password",
        state: { data: response.data },
      });
    } catch (error) {
      setErrorMessage("Email ID not found");
    }
  };

  return (
    <AuthCanvas head="Forgot Password">
      <form onSubmit={handleSubmit(resetPassword)}>
        <Controller
          control={control}
          name="email"
          rules={{ required: "Email is required" }}
          render={({ onChange, value, name }) => (
            <TextInput
              showAsterisk
              placeholder="Email"
              label="Email"
              error={errors.email?.message || errorMessage}
              onChange={onChange}
              name={name}
              default={value}
            />
          )}
        />

        <div className="button-outer row">
          <div className="col text-left my-auto text-capitalize">
            <Button btnlink link={RouteKeys.Login} className="text-capitaliz">
              Login
            </Button>
          </div>
          <div className="col text-right">
            <Button type="submit">Continue</Button>
          </div>
        </div>
      </form>
    </AuthCanvas>
  );
};

export default ForgotPassword;
